/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';

interface IProps {
  direction?: 'horizontal' | 'vertical';
  width?: string;
  height?: string;
  thickness?: string;
  color?: string;
  margin?: string;
}

const Wrapper = styled.div<IProps>`
  height: ${(props) => (props.direction === 'vertical' ? props.height || '100%' : props.thickness || '1px')};
  width: ${(props) => (props.direction === 'vertical' ? props.thickness || '1px' : props.width || '100%')};
  margin: ${(props) => props.margin || '0px'};
  background-color: ${(props) => props.color || color.BLACK_2};
`;

const Line: React.FC<IProps> = ({ direction = 'horizontal', width, height, margin, thickness, color }) => {
  return (
    <Wrapper direction={direction} width={width} height={height} margin={margin} thickness={thickness} color={color} />
  );
};

export default Line;
